'use client';

import { useTextSize, type TextSize } from '@/context/TextSizeContext';

const OPTIONS: { value: TextSize; label: string; abbr: string }[] = [
  { value: 'standard',    label: 'Standard',    abbr: 'A'  },
  { value: 'large',       label: 'Large',       abbr: 'A'  },
  { value: 'extra-large', label: 'Extra Large', abbr: 'A'  },
];

export default function TextSizeControl() {
  const { textSize, setTextSize } = useTextSize();

  return (
    <div className="px-4 py-3">
      <p className="font-body text-[12px] font-semibold text-sage uppercase tracking-wider mb-2">
        Text Size
      </p>
      <div className="flex gap-2">
        {OPTIONS.map(({ value, label, abbr }, i) => {
          const active = textSize === value;
          const sizes = ['text-[14px]', 'text-[17px]', 'text-[20px]'];
          return (
            <button
              key={value}
              onClick={() => setTextSize(value)}
              aria-label={label}
              aria-pressed={active}
              className={[
                'flex-1 flex flex-col items-center justify-center py-2.5 rounded-xl border transition-all',
                active
                  ? 'border-deep-green bg-light-sage text-deep-green'
                  : 'border-sand bg-white text-sage hover:border-[#b4c9aa]',
              ].join(' ')}
            >
              <span className={`font-heading font-bold leading-none ${sizes[i]}`}>{abbr}</span>
              <span className="font-body text-[10px] mt-1 leading-none opacity-75">{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
